<template>
    <div class="sb-site-container" data-test-id="site-container">
        <l-nav />
        <l-main>
            <slot />
        </l-main>
    </div>
</template>

<script>
import LMain from "@/components/LMain";
import LNav from "@/components/LNav";

export default {
    components: {
        LMain,
        LNav,
    },
};
</script>

<style scoped>
.sb-site-container {
    padding-top: 70px;
}
</style>
